import { useMutation, useQueries, useQueryClient } from "@tanstack/react-query";
import { useContext, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../../redux/store";
import apiCall from "../../../../utils/apiCall";
import { AxiosError } from "axios";
import { CircularProgress } from "@mui/material";
import styles from "../../Applicants/css/display-applicant.module.css";
import { FilterDropDown, Loading } from "../../../../ui-components";
import { AiOutlineSearch as SearchIcon } from "react-icons/ai";
import { IoReload as ReloadIcon } from "react-icons/io5";
import ApprovalTable from "./ApprovalTable";
import BatchApprovalTable from "./BatchApprovalTable";
import styled from "@emotion/styled";
import BatchApprovalModal from "../Modal/BatchApprove";
import { NotificationContext } from "../../../../providers/notification";
import css from "../css/approve-modal.module.css";
import { updateParams } from "../../../../reduxSlice/pendingApprovalParamsSlice";
import * as Yup from "yup";
import { ApprovalContext } from "./Approvals";
import { ExNyRoute } from "../../../../utils/allRouteId";
import { RouteResponse } from "../../../../types/index";
import {
  FetchAllRoutes,
  reOrderFetchedData,
} from "../../../../hooks/FetchData";

//Validation
// const validationSchema = Yup.object().shape({
//     comment: Yup.string().required('Comment name is required'),
// });
const validationSchema = Yup.object().shape({
  comment: Yup.string().required(),
});

//Interface
interface RoleProps {
  Id: string;
  Name: string;
  NormalizedName: string;
}

interface RoleResponse {
  data: RoleProps[];
}

interface GetAllPendingApprovals {
  ApplicantId?: any;
  TitleId: number;
  LastName: string;
  FirstName: string;
  MiddleName: string;
  Email: string;
  PhoneNumber: string;
  CorprateName?: any;
  StateCode?: any;
  StartDate?: any;
  isCorporate?: any;
  DateBirth?: any;
  ContactAddress?: any;
  StateOriginId?: any;
  LGAId?: any;
  StateId?: any;
  ZoneId?: any;
  NYSCUploadDocumentUrl?: any;
  GenderId?: any;
  MaritalStatusId?: any;
  IsChangeofName?: any;
  UploadPictureUrl?: any;
  UploadChangeofNameUrl?: any;
  TabId?: any;
  IsSubmitted: boolean;
  RouteId: number;
  AppMemberId: string;
  TargetedMembers?: any;
  TargetedMembersId: number;
  ApprovalRoleId: string;
  ApprovalIndex: number;
  Status: number;
  FinalApproval: number;
  RouteName: string;
  AppprovalComment?: any;
  ApprovalActionTypes: number;
  AppprovalAction?: any;
  ApprovalActionTypeId?: any;
  ApplicationDate: string;
}

interface GetAllPendingApprovalsResponse {
  data: GetAllPendingApprovals[];
}

interface Routes {
  RouteName: string;
  RouteId: number;
}

interface RouteData {
  Data: Routes[];
}

interface RoutesResponse {
  data: RouteData;
}

interface ApprovalType {
  ApprovalTypeId: number;
  ApprovalTypName: string;
}

interface ApprovalTypeResponse {
  data: ApprovalType[];
}

interface ExamEntryLevelsData {
  Id: number;
  Name: string;
  RouteId: number;
  ExamAmount: number;
  ExemptionAmount: number;
  IsActive: boolean;
}

export const DisplayApproval = (props: any) => {
  const roleId = useSelector((state: RootState) => state?.user.roleId);
  const userId = useSelector((state: RootState) => state?.user?.userId);
  const batchApprovalData = useSelector(
    (state: RootState) => state?.batchApproval.data
  );
  const pendingApprovalParams = useSelector(
    (state: RootState) => state?.updatePendingApprovalParams
  );
  const [statusF, setStatusF] = useState<any>("");
  const [roleData, setRoleData] = useState<RoleProps[]>([]);
  const [batchApprovalComment, setBatchApprovalComment] = useState("");
  const [route, setRoute] = useState<any>("");
  const [id, setId] = useState(roleId); //pendingApprovalParams?.roleId
  const [routeId, setRouteId] = useState<number>(); //pendingApprovalParams?.roleId
  const [approvalTypeId, setApprovalTypeId] = useState(""); //pendingApprovalParams?.approvalTypeId;
  const [isApproving, setIsApproving] = useState(false);
  const [searchData, setSearchData] = useState("");
  const [searchData1, setSearchData1] = useState("");
  const [roleName, setRoleName] = useState("");
  const [EntryLevelId, setEntryLevelId] = useState<number>();
  const [studentTypeId, setStudentTypeId] = useState<number>();
  const [studentTypeName, setStudentTypeName] = useState<string>("");

  const queryClient = useQueryClient();
  const { showNotification } = useContext(NotificationContext);
  const dispatch = useDispatch();
  const { setRouteName } = useContext(ApprovalContext);

  //const setRouteName = props?.setRouteName;
  const showBatchApprovalModal = props?.showBatchApprovalModal;
  const handleCloseBatchApproval = props?.handleCloseBatchApproval;
  // const entryLevelData = props?.entryLevelData;

  // const routeId = route ? route?.val : '';
  // const approvalTypeId = statusF?.val || '';

  const { isLoading, data } = FetchAllRoutes();

  const reOrderedAllRoutes = data
    ? reOrderFetchedData((data as RouteResponse)?.Data)
    : [];

  const allRoutes = isLoading
    ? []
    : reOrderedAllRoutes.map((item) => {
        return { name: item?.RouteName, val: item?.RouteId };
      });

  const getAllPendingApprovals =
    async (): Promise<GetAllPendingApprovalsResponse> => {
      const url = `/Approval/GetAllPendingApprovalsByQueryString?expectedValues=%3FRoleId%3D${id}%26RouteId%3D${routeId}%26ApprovalTypeId%3D${approvalTypeId}%26membershipTypeId%3D%26studentType%3D${studentTypeId}`;
      return await apiCall().get(url);
    };

  const getApprovalTypes = async (): Promise<ApprovalTypeResponse> => {
    return await apiCall().get("/ApprovalType/GetApprovalTypes");
  };

  const postBatchApproval = async (data: any[]): Promise<any> => {
    return await apiCall().post("/Approval/NextApprovalBulk", data);
  };

  const getAllExamEntryLevels = async (): Promise<ExamEntryLevelsData[]> => {
    return (await apiCall().get("/SetUp/GetAllExemption"))?.data
      ?.Data as ExamEntryLevelsData[];
  };

  const batchApprovalMutation = useMutation(
    ["post-batch-approval"],
    postBatchApproval,
    { retry: 0 }
  );

  const handlePostBatchApproval = async (action: string) => {
    const response = await validationSchema
      .isValid({
        comment: batchApprovalComment,
      })
      .then((valid) => valid);
    // const body = new FormData();

    const batchApprovalPayloadList = batchApprovalData.map((item) => {
      return {
        ApprovalTypeId: 1,
        RouteId: item?.RouteId,
        AppMemberId: item?.AppMemberId,
        TargetedMembers: "Applicants",
        TargetedMembersId: item?.TargetedMembersId,
        ApprovalRoleId: item?.ApprovalRoleId,
        ApprovalIndex: item?.ApprovalIndex,
        Status: item?.Status,
        FinalApproval: item?.FinalApproval,
        ApprovalComment: "",
        ApprovalActionTypeId: "1",
        ApprovalActionTypes: action,
        ApprovalAction: action,
        Email: item?.Email,
        ApprovalUserId: userId,
        ExemptionId: EntryLevelId ? String(EntryLevelId) : 1,
        examId: 1,
      };
    });

    action === "Approved" ? setIsApproving(true) : setIsApproving(false);

    try {
      // if(!response) throw 'Comment is Required';
      if (!Response) {
        // Do nothing
      }
      if (routeId == ExNyRoute && !EntryLevelId)
        throw new Error("Set Exam Entry Level");
      if (batchApprovalPayloadList.length < 1)
        throw new Error("select applicants to approve");
      await batchApprovalMutation.mutateAsync(batchApprovalPayloadList, {
        onSuccess: () => {
          showNotification({
            message: "Batch Approval Successful",
            type: "success",
          });
          queryClient.invalidateQueries(["get-approval"]);
          handleCloseBatchApproval();
          setBatchApprovalComment("");
        },
      });
    } catch (error: any) {
      showNotification({
        message: error?.response?.data?.Message || error.message || error,
        type: "error",
      });
    }
  };

  const postBatchDecline = async (data: any[]): Promise<any> => {
    return await apiCall().post("/Approval/ApprovalDeclinedBulk", data);
  };

  const batchDeclineMutation = useMutation(
    ["post-batch-decline"],
    postBatchDecline,
    { retry: 0 }
  );

  const handlePostBatchDecline = async (action: string) => {
    const response = await validationSchema
      .isValid({
        comment: batchApprovalComment,
      })
      .then((valid) => valid);

    const batchDeclinePayloadList = batchApprovalData.map((item) => {
      return {
        ApprovalTypeId: 1,
        RouteId: item?.RouteId,
        AppMemberId: item?.AppMemberId,
        TargetedMembers: "Applicants",
        TargetedMembersId: item?.TargetedMembersId,
        ApprovalRoleId: item?.ApprovalRoleId,
        ApprovalIndex: item?.ApprovalIndex,
        Status: item?.Status,
        FinalApproval: item?.FinalApproval,
        ApprovalComment: batchApprovalComment,
        ApprovalActionTypeId: "2",
        ApprovalActionTypes: action,
        ApprovalAction: action,
        Email: item?.Email,
        ApprovalUserId: userId,
        ExemptionId: 1,
        examId: 1,
      };
    });

    action === "Approved" ? setIsApproving(true) : setIsApproving(false);

    try {
      if (!response) throw new Error("Comment is Required");

      await batchDeclineMutation.mutateAsync(batchDeclinePayloadList, {
        onSuccess: () => {
          showNotification({
            message: "Approval Decline Successful",
            type: "success",
          });
          queryClient.invalidateQueries(["get-approval"]);
          handleCloseBatchApproval();
        },
      });
    } catch (error: any) {
      showNotification({
        message: error?.response?.data?.Message || error.message || error,
        type: "error",
      });
    }
  };

  const [getAllPendingApprovalQuery, getApprovalTypeQuery, getAllEntryLevelQuery] = useQueries({
    queries: [
      {
        queryKey: [
          "get-approval",
          id,
          routeId,
          approvalTypeId,
          searchData,
          studentTypeId,
        ],
        queryFn: getAllPendingApprovals,
        refetchOnWindowFocus: false,
      },
      { queryKey: ["get-approval-types"], queryFn: getApprovalTypes },
      { queryKey: ["get-entry-level"], queryFn: getAllExamEntryLevels },
    ],
  });

  const approvalTypeData = getApprovalTypeQuery?.data?.data;

  const entryLevelData = getAllEntryLevelQuery?.data;

  const getRoleByUserId = async () => {
    return (await apiCall().post(
      `Authentication/GetRoleByUserId?userid=${userId}`
    )) as RoleResponse;
  };

  const getRoleByUserIdMutation = useMutation(
    ["get-roleById"],
    getRoleByUserId,
    {
      retry: 0,
      onSuccess: () => {
        queryClient.invalidateQueries(["exam_approval"]);
      },
    }
  );

  const roleError = getRoleByUserIdMutation?.error as AxiosError;
  const roleErrorMessage = roleError?.message;

  const roleHandler = async () => {
    try {
      const data = await getRoleByUserIdMutation.mutateAsync();
      setRoleData(data?.data);
    } catch (error: any) {}
  };

  const mappedRoleData: any[] = roleData?.map((item) => {
    let role = {
      val: item?.Id,
      name: item?.Name,
    };

    return role;
  });

  const handleRoleIdChange = (role: { val: string; name: string }) => {
    setId(role?.val);
    setRoleName(role?.name);
    dispatch(
      updateParams({
        ...pendingApprovalParams,
        roleId: role.val,
      })
    );
  };

  const handleRouteIdChange = (route: { val: number; name: string }) => {
    setRouteId(route?.val);

    setRouteName(route?.name);
    setRoute(route?.name);

    dispatch(
      updateParams({
        ...pendingApprovalParams,
        routeId: route.val?.toString(),
      })
    );
  };

  const handleStudentTypeChange = (type: { val: number; name: string }) => {
    setStudentTypeId(type.val);
    setStudentTypeName(type.name);
  };

  // const mappedRouteData: any[] | undefined = routeData?.map((item) => {
  //   let route = {
  //     val: item?.RouteId,
  //     name: item?.RouteName,
  //   };

  //   return route;
  // });

  const mappedApprovalTypeData: any[] | undefined = approvalTypeData?.map(
    (item) => {
      let approvalType = {
        val: item?.ApprovalTypeId,
        name: item?.ApprovalTypName,
      };
      return approvalType;
    }
  );

  const handleApproveBatchApproval = async () => {
    await handlePostBatchApproval("Approved");
  };

  const handleRejectBatchApproval = async () => {
    await handlePostBatchDecline("Rejected");
  };

  useEffect(() => {
    roleHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const preFilterValue = ((getAllPendingApprovalQuery?.data?.data as any)
    ?.Data as any[])
    ? ((getAllPendingApprovalQuery?.data?.data as any)?.Data as any[])
    : getAllPendingApprovalQuery?.data?.data;

  const filteredData = preFilterValue?.filter((x) =>
    Object.values(x).join(" ").toLowerCase().includes(searchData.toLowerCase())
  );

  const filteredData1 = preFilterValue?.filter((x) =>
    Object.values(x).join(" ").toLowerCase().includes(searchData1.toLowerCase())
  );

  const SwitchEntryLevel = (data: { val: number; name: string }) => {
    setEntryLevelId(data?.val);
  };

  const entryLevelOptions = entryLevelData
    ? entryLevelData?.map((item: ExamEntryLevelsData) => {
        return {
          val: item?.Id,
          name: item?.Name,
        };
      })
    : [];
    
  return (
    <div className={styles.container}>
      <div className={styles.filterDiv}>
        <label className={styles.searchForm}>
          <span className={styles.sI}>
            <SearchIcon />
          </span>
          <input
            value={searchData}
            onChange={(e) => setSearchData(e.target.value)}
            type="text"
            placeholder="Search"
          />
          <button className={styles.rBtn} type="submit">
            <ReloadIcon />
          </button>
        </label>

        <FilterDropDown
          onChange={handleRouteIdChange}
          text={route ? `${route}` : "Membership Route"}
          bg="#0A3922"
          color="#fff"
          options={allRoutes}
        />

        {routeId === 1 && (
          <FilterDropDown
            onChange={handleStudentTypeChange}
            text={studentTypeName ? studentTypeName : "Student Type"}
            bg="#E2E4E9"
            options={studentType}
          />
        )}

        {/* <FilterDropDown
          onChange={setStatusF}
          text="Approval Type"
          bg="#E2E4E9"
          options={mappedApprovalTypeData}
        /> */}
        {/* <FilterDropDown onChange={setStatusF} text="Actions" bg="#E2E4E9" options={option4} /> */}
        {/* <FilterDropDown onChange={setStatusF} text="Status" bg="#E2E4E9" options={optb} /> */}
        <FilterDropDown
          onChange={handleRoleIdChange}
          text={roleName ? roleName : "Role"}
          options={mappedRoleData}
        />
      </div>

      <div className={styles.div}>
        {getAllPendingApprovalQuery?.isFetching ? (
          <CircularProgress
            sx={{
              fontSize: "1rem",
              marginInline: "auto",
              display: "block",
              marginBlock: "2rem",
            }}
          />
        ) : getRoleByUserIdMutation.isError ? (
          <StyledError>{roleErrorMessage}</StyledError>
        ) : filteredData && filteredData?.length > 0 ? (
          <ApprovalTable
            data={
              searchData.length > 0
                ? filteredData
                : getAllPendingApprovalQuery?.data?.data
            }
          />
        ) : (
          <NoResult>No Results</NoResult>
        )}

        <BatchApprovalModal
          open={showBatchApprovalModal}
          cancel={handleCloseBatchApproval}
          header={"Batch Approval"}
          maxWidth={"1300px"}
          content={
            <Container>
              {getAllPendingApprovalQuery?.isFetching ? (
                <CircularProgress
                  sx={{
                    fontSize: "1rem",
                    marginInline: "auto",
                    display: "block",
                    marginBlock: "2rem",
                  }}
                />
              ) : getRoleByUserIdMutation.isError ? (
                <StyledError>{roleErrorMessage}</StyledError>
              ) : (
                <BatchApprovalTable
                  setSearchData={setSearchData1}
                  searchData={searchData1}
                  data={
                    searchData1.length > 0
                      ? filteredData1
                      : getAllPendingApprovalQuery?.data?.data
                  }
                />
              )}
              <div style={{ paddingBlock: "20px" }}>
                {routeId == ExNyRoute && (
                  <FilterDropDown
                    onChange={SwitchEntryLevel}
                    width100={true}
                    text={"Exam Entry Levels"}
                    bg="#0A3922"
                    color="#fff"
                    options={entryLevelOptions}
                    // replace={"true"}
                  />
                )}
              </div>

              <div className={css.comment}>
                <div className={css.title}>Comment</div>
                <textarea
                  value={batchApprovalComment}
                  onChange={(e) => setBatchApprovalComment(e.target.value)}
                  rows={6}
                ></textarea>
              </div>
              <div className={css.btnDiv}>
                <button
                  disabled={
                    batchApprovalMutation.isLoading ||
                    batchDeclineMutation.isLoading
                  }
                  style={{
                    border: "1px solid #EB5757",
                    color: "#EB5757",
                    cursor: "pointer",
                  }}
                  onClick={handleRejectBatchApproval}
                >
                  {batchDeclineMutation.isLoading ? "Declining..." : "Decline"}
                </button>
                <button
                  disabled={
                    batchApprovalMutation.isLoading ||
                    batchDeclineMutation.isLoading
                  }
                  onClick={handleApproveBatchApproval}
                  style={{
                    border: "1px solid #5BC065",
                    color: "#fff",
                    backgroundColor: "#5BC065",
                    cursor: "pointer",
                  }}
                >
                  {batchApprovalMutation.isLoading ? "Approving..." : "Approve"}
                </button>
              </div>
            </Container>
          }
        />
      </div>
    </div>
  );
};

const studentType = [
  { name: "Exam", val: 1 },
  { name: "NYSC", val: 2 },
];

const StyledError = styled("p")`
  color: red;
  font-size: 1.4rem;
  display: flex;
`;

const Container = styled("div")`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-bottom: 48px;
`;
const NoResult = styled.div`
  margin-block-start: 0px;
`;
